class ClientSharedResourceUsersController {
  static controller($scope, $state, ResourceService, $translate, $mdDialog) {
    'ngInject';

    ResourceService.getSharedResources()
    .then(function(data){
      $scope.resources = data.resources;
    });

    // TODO add notes as directive (the same view for client and instalator)
    $scope.showNotesDialog = function(ev, resource) {
      $mdDialog.show({
        controller: NotesDialogController,
        template: `
          <md-dialog aria-label="note" flex="60">
            <md-toolbar>
              <div class="md-toolbar-tools">
                <h2>{{"RESOURCE.NOTES" | translate}}</h2>
              </div>
            </md-toolbar>
            <md-dialog-content>
              <div class="md-dialog-content">
                <div layout="column" layout-align="space-around center">
                  <div layout-margin><strong>{{"COMMONS.YOU" | translate}}:</strong> {{clientNote || '-'}}</div>
                  <div layout-margin><strong>{{"USERS.INSTALATOR.TITLE" | translate}}:</strong> {{instalatorNote  || '-'}}</div>
                </div>
              </div>
            </md-dialog-content>
        
            <md-dialog-actions layout="row">
              <button type="button" class="md-button " ng-click="closeDialog()">
                {{"COMMONS.OK" | translate}}
              </button>  
            </md-dialog-actions>
          </md-dialog>
        `,
        locals : {
          resource : resource
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        fullscreen:true,
      });
    };

    function NotesDialogController($rootScope, $scope, $state, $mdDialog, $translate, resource) {
      $scope.closeDialog = function() {
        $mdDialog.cancel();
      }

      ResourceService.getInstalatorNoteToResource(resource.shareId)
      .then(function(data){
        $scope.instalatorNote = data.note;
      });

      ResourceService.getClientNoteToResource(resource.shareId)
      .then(function(data){
        $scope.clientNote = data.note;
      });
    }

    $scope.showAddNoteDialog = function(ev, resource) {
      $mdDialog.show({
        controller: AddNoteDialogController,
        template: `
          <md-dialog aria-label="note" flex="80">
            <md-toolbar>
              <div class="md-toolbar-tools">
                <h2>{{"RESOURCE.ADD_NOTE" | translate}}</h2>
              </div>
            </md-toolbar>
        
            <form name="noteForm" class="text-left" ng-submit="addNote(noteForm)" novalidate>
              <md-dialog-content>
                <div class="md-dialog-content">
                  <md-input-container md-no-float class="md-block">
                    <label>{{ "RESOURCE.NOTE" | translate}}</label>
                    <textarea ng-required="true" name="note" ng-model="note" md-maxlength="1024" rows="5" md-select-on-focus></textarea>  
                  </md-input-container>
                </div>
              </md-dialog-content>
          
              <md-dialog-actions layout="row">
                <button type="button" class="md-button " ng-click="closeDialog()">
                  {{"COMMONS.CANCEL" | translate}}
                </button>  
                <button type="submit" class="md-button md-raised md-primary">
                  {{"COMMONS.SEND" | translate}}
                </button>
              </md-dialog-actions>
            </form>
          </md-dialog>
        `,
        locals : {
          resource : resource,
          parentScope : $scope
        },
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose:false,
        fullscreen:true,
      });
    };

    function AddNoteDialogController($rootScope, $scope, $state, $mdDialog, $translate, resource, parentScope) {
  
      $scope.closeDialog = function() {
        $mdDialog.cancel();
      }

      $scope.addNote = function(form){
        if(!form.$valid){
          return;
        }

        ResourceService.addNoteToResource(resource.shareId, form.note.$modelValue)
        .then(function(data){
          $scope.closeDialog();
          $rootScope.toast($translate.instant('RESOURCE.NOTE_ADDED'));
          ResourceService.getSharedResources()
          .then(function(data){
            $scope.resources = data.resources;
          });
        });
      };
    }
  };
}

export default ClientSharedResourceUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-shared-resources.users.controller.js